<template>
    <div v-if="initialized" class="card">
        <div class="card-header">
            {{ label || 'Commands' }}
        </div>
        <div class="card-body card-commands">
            <div>
                <template v-for="command in commands">
                    <command-component
                        :key="command.name"
                        v-bind="command"
                        v-on:input="(data) => updateCommand(command.name, data)"
                        v-on:show="() => showCommand(command.name)"
                        v-on:hide="() => hideCommand(command.name)"
                        v-on:run="() => runCommand(command)"
                        v-on:stop="() => stopCommand(command)"
                        v-on:track="() => trackCommand(command)"
                        ></command-component>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import Vuex from 'vuex';
import CommandComponent from './CommandComponent';

export default {
    data() {
        return {
            commands: {},
            initialized: false,
        }
    },

    props: ['label', 'filter', 'sort', 'hideArguments'],

    components: {
        CommandComponent,
    },

    mounted() {
        return this.helpers('api').getData('/commands')
            .then(res => {
                this.commands = _.chain(res.data)
                    .filter(this.filter || _.identity)
                    .sortBy(this.sort || 'name')
                    .map(command => {
                        const { name, arguments: args, options: opts, meta } = command;

                        const progress = _.get(meta, 'progress', null);
                        const tracking = _.get(meta, 'tracking', null);

                        return [name, {
                            name,

                            settings: _.assign(
                                _.values(args).reduce((tmp, arg) => {
                                    return { ...tmp, [arg.name]: arg.default };
                                }, {}),

                                _.values(opts).reduce((tmp, opt) => {
                                    return { ...tmp, [`--${opt.name}`]: opt.default };
                                }, {}),
                            ),

                            showing: false,

                            schema: {
                                arguments: args,
                                options: opts,
                            },

                            running: !_.chain(progress)
                                .get('status', 'finished')
                                .isEqual('finished')
                                .value(),
                            progress,
                            tracking,
                            hideArguments: this.hideArguments,
                        }]
                    })
                    .fromPairs()
                    .value()
                this.initialized = true;
            })
    },

    beforeDestroy() {
        _.chain(this.commands)
            .each(command => {
                if (command.intervalId) {
                    clearInterval(command.intervalId);
                }
            })
            .value()
    },

    computed: {

    },

    methods: {
        ...Vuex.mapActions(['addNotification']),

        updateCommand(name, data) {
            const command = _.get(this.commands, name);

            if (!command) return;

            command.settings = data;
            this.$forceUpdate();
        },

        showCommand(name) {
            const command = _.get(this.commands, name);
            console.log(command);

            if (!command) return;

            command.showing = true;
        },

        hideCommand(name) {
            const command = _.get(this.commands, name);

            if (!command) return;

            command.showing = false;
        },

        runCommand(command) {

            if (!command) return;

            command.running = true;
            const args = _.chain(command)
                .get('schema.arguments', {})
                .keys()
                .map(key => {
                    // check for argument
                    return [key, _.get(command, `settings.${key}`)]
                })
                .fromPairs()
                .value();
            const opts = _.chain(command)
                .get('schema.options', {})
                .keys()
                .map(key => {
                    // check for argument
                    return [key, _.get(command, `settings.--${key}`)]
                })
                .fromPairs()
                .value();

            const tracking = _.get(command, 'meta.tracking');

            if (tracking) {
                this.trackCommand(command);
            }
            return this.helpers('api').runCommand(command.name, args, opts)
                .then(() => {
                    command.running = false;
                    this.addNotification({
                        type: 'message',
                        message: `Command ${command.name} finish`,
                    });

                    this.$forceUpdate();
                })
        },

        trackCommand(command) {
            command.intervalId = setInterval(() => {
                const tracking = _.get(command, 'tracking');
                const trackingUrl = this.helpers('uriFormat')(tracking);

                this.helpers('api').getData(trackingUrl)
                    .then(res => {
                        console.log(res);
                        command.progress = res;
                        if (res.status != 'finished') {
                            return;
                        }

                        if (res.error) {
                            this.addNotification({
                                type: 'error',
                                message: `Command ${name} failed: ${res.error}`,
                            });
                        } else {
                            this.addNotification({
                                type: 'message',
                                message: `Command ${name} finish`,
                            });
                        }

                        command.running = false;
                        clearInterval(command.intervalId);
                        this.$forceUpdate();
                    });
            }, 3000)
        },

        stopCommand(command) {
            const tracking = _.get(command, 'tracking');
            const trackingUrl = this.helpers('uriFormat')(tracking);

            this.helpers('api').delData(trackingUrl)
                .then(res => {
                    command.progress = res;
                    command.running = false;
                    clearInterval(command.intervalId);
                    this.$forceUpdate();
                });
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/dashboard-elements/CommandPanelComponent.vue